import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { RoutesService } from '../../services/routes.service';
import { ComponentService } from '../../services/component.service';


import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NicaMenuService } from '../../services/nica-menu.service';
import { Routes, Router } from '@angular/router';


class MenuPreferiti{
  text?:string;
  id:number;
  visible:boolean;
  parent:number;
  disabled:boolean;
  active:boolean;
  items:[
    {
      text:string;
      key:string;
      id:number;
      parent:number;
      visible:boolean;
      disabled:boolean;
      items:[
        {
          id:number;
          idfather:number;
          text:string;
          fav:boolean;
          visible:boolean;
          disabled:boolean;
        }
      ]
      
      
    }
  ];
  
}



@Component({
  selector: 'app-nica-pref-menu',
  templateUrl: './nica-pref-menu.component.html',
  styleUrls: ['./nica-pref-menu.component.css']
})


export class NicaPrefMenuComponent implements OnInit {
  
  @Input() listType:string;

  menuUrl = 'assets/main.json';
  menuVisible:boolean;
  listVisible:boolean;  
  preferiti:any;
  defaultVisible:any;
  tooltip: any; 
  howToShowSubmenuMode:any[];
  showSubmenuModes: { name: string; delay: { show: number; hide: number; }; }[];
  showFirstSubmenuModes: {
    name: string; delay: {
      show: number; hide: number;
    };
  };
  constructor(private http:HttpClient, private menuService: NicaMenuService,private router: Router,private componentService: ComponentService) {
    
  }
 
  
  ngOnInit() {
 
    this.menuService.menuPref.subscribe(data=>{
      //this.preferiti=data;
      this.initFavMenu(data);

      this.showSubmenuModes = [{
        name: 'onHover',
        delay: { show: 0, hide: 500 },
      }, {
        name: 'onClick',
        delay: { show: 0, hide: 300 },
      }];
      this.showFirstSubmenuModes = this.showSubmenuModes[0];

    });
    
     if(this.listType=='menu'){
       this.menuVisible = true
     }
    if(this.listType=='lista'){

      this.listVisible= true
    }
  }


  
  

  rimuoviPreferiti(item, ev) {

    item.fav = false;
    
  }

 

  initFavMenu(itm){
   
    let res = this.chooseItems(itm);
   
    this.preferiti = res
   
  }
  chooseItems(itm,arrayItem=[],k=0){
    
    
    for(let i = 0 ; i < itm.length; i++){
      
      if(itm[i].items){
        
        
        if(typeof itm[i].key !== 'undefined'){
          
          arrayItem.push({
            text:itm[i].key,
            items:[]
          })
        }

        this.chooseItems(itm[i].items,arrayItem,i)
       
      }else{
        
        if(itm[i].fav){
          
          
          const index = arrayItem[k].items.findIndex(object => object.id === itm[i].id);
          //console.log(index)
          if (index === -1) {
            arrayItem[k].items.push(itm[i]);
          }  

          itm[i].tooltip=false;
         
          
          

        }
      }  
      
    } 
    
   
    return arrayItem.filter(res=>res.items.length>0)
  } 
    
  
  itemAction(ev){
  
      ev.event.stopPropagation()
      const itemData = ev.itemData;
     /*
      
      let path = itemData.text.toLowerCase().replace(/[^a-zA-Z ]/g, '');
      path =  path.replace(/\s/g, '-');
  
      const pathDef = 'main/'+path
      
      this.router.navigate([pathDef])
      .then(data => {
        
        console.log('Route exists, redirection is done',data);
      })
      .catch(e => {
        console.log('Route not found, redirection stopped with no error raised',e);
      });
    
      */

       ///Con Componente

      //per i submenu 
      if(itemData.items){
        console.log(itemData.items)
        return 
      }

      ////


      let path = itemData.text;
      let component = itemData.controller
      if(component){
        let tabsJson =[
          {
            id:itemData.id,
            title: path,
            icon: 'user',
            key:'dash',
            component:component,
            
  
          }
        ];
        this.componentService.addNewTab('dashboard', tabsJson);
    
      }else{

        alert('Attenzione Funzione non disponibile')
      }
      
    
  }

  setVisible(itm){
    
    if(!itm.tooltip){
      itm.tooltip = true
    }else{
      itm.tooltip = false;
    }
    
  }

  
    
}